export default {"src":"/_next/static/media/lightning.113811ef.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};